import { composeClassNames, withDefault } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import { Badge } from "react-bootstrap";
import Text from "src/components/Text";
import Translate from "src/components/Translate";
import { sBadge } from "src/styles/sBadge.module.scss";
import { sPrice } from "src/styles/sPrice.module.scss";
import { VariantColor } from "src/types/VariantColor";
import { VariantSize } from "src/types/VariantSize";

type Props = {
  className?: (string | string) | null | undefined;
  currency: string;
  price: number;
  priceBasic?: number;
  size?: VariantSize;
  style?: CSSProperties | null | undefined;
  title?: string | null | undefined;
  variant?: VariantColor;
};

const Price = ({
  className,
  currency,
  price,
  priceBasic,
  size,
  style,
  title,
  variant,
}: Props) => {
  return (
    price &&
    currency && (
      <div
        className={composeClassNames([sPrice, "price", className])}
        style={style}
      >
        <Text size={size} className="price-title">
          <Translate tKey={title ? title : `Price`} />:
        </Text>
        <Badge
          pill={true}
          variant={withDefault(variant, "secondary")}
          className={composeClassNames([sBadge, "badge-light"])}
        >
          {priceBasic && priceBasic > price ? (
            <Text size={size} className="price-basic">
              <small>
                {priceBasic} <Translate tKey={currency.toUpperCase()} />
              </small>
            </Text>
          ) : null}
          <Text size={size} width={`semibold`} className="price-final">
            {price} <Translate tKey={currency.toUpperCase()} />
          </Text>
        </Badge>
      </div>
    )
  );
};

export default Price;
